// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_1cF","cls2":"ReferenceCard-cls2_MMW ReferenceCard-cls1_1cF"};